/* ==========================================================================
   Oakton — review carousel
   Pages a flex track by whole viewports. Slide width comes from CSS, so the
   number of slides per page changes with the breakpoint automatically.
   ========================================================================== */

(function () {
  'use strict';

  function setup(root) {
    var track = root.querySelector('[data-ok-track]');
    var prev = root.querySelector('[data-ok-prev]');
    var next = root.querySelector('[data-ok-next]');
    if (!track) return;

    var page = 0;

    function pages() {
      var slide = track.firstElementChild;
      if (!slide) return 1;
      var perView = Math.max(1, Math.round(track.parentElement.offsetWidth / slide.offsetWidth));
      return Math.max(1, Math.ceil(track.children.length / perView));
    }

    function apply() {
      var total = pages();
      if (page >= total) page = total - 1;
      if (page < 0) page = 0;
      track.style.transform = 'translateX(' + -page * 100 + '%)';

      if (prev) prev.disabled = total <= 1;
      if (next) next.disabled = total <= 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        var total = pages();
        page = (page - 1 + total) % total;
        apply();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var total = pages();
        page = (page + 1) % total;
        apply();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        page = 0;
        apply();
      }, 150);
    });

    apply();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ok-carousel]');
    [].slice.call(roots).forEach(function (root) {
      if (root.dataset.okReady === 'true') return;
      root.dataset.okReady = 'true';
      setup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
